import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Any links shared?",
    radioYes: "Yes",
    radioNo: "No",
    platformHeader: "What is the platform(s) used by the fraudster",
    mobileLabel: "Mobile:",
    linkLabel: "Link:",
    urlLabel: "URL:",
    placeholderMobile: "Enter Mobile Number",
    placeholderLink: "Enter Profile ID / URL",
    placeholderUrl: "Enter Website / URL",
    ok: "OK",
    alert: "Please answer the current question before proceeding to the next one.",
    errorSelect: "Please select an option before proceeding.",
  },
  Hi: {
    header: "क्या कोई लिंक साझा की गई है?",
    radioYes: "हाँ",
    radioNo: "नहीं",
    platformHeader: "धोखेबाज़ द्वारा उपयोग किए गए प्लेटफ़ॉर्म क्या हैं",
    mobileLabel: "मोबाइल:",
    linkLabel: "लिंक:",
    urlLabel: "URL:",
    placeholderMobile: "मोबाइल नंबर दर्ज करें",
    placeholderLink: "प्रोफ़ाइल आईडी / URL दर्ज करें",
    placeholderUrl: "वेबसाइट / URL दर्ज करें",
    ok: "ठीक है",
    alert: "कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
    errorSelect: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
  },
  Kn: {
    header: "ವಂಚಕರು ನಿಮ್ಮೊಂದಿಗೆ ಯಾವುದೇ ಲಿಂಕ್ ಗಳನ್ನು ಹಂಚಿಕೊಂಡಿದ್ದಾರೇಯೇ?",
    radioYes: "ಹೌದು",
    radioNo: "ಇಲ್ಲ",
    platformHeader: "ಹೌದು ಎಂದಾದರೆ, ವಂಚಕರು ಬಳಸಿದ ಮಾಧ್ಯಮವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ.",
    mobileLabel: "ಮೊಬೈಲ್:",
    linkLabel: "ಲಿಂಕ್:",
    urlLabel: "URL:",
    placeholderMobile: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    placeholderLink: "ಪ್ರೊಫೈಲ್ ಐಡಿ / URL ನಮೂದಿಸಿ",
    placeholderUrl: "ವೆಬ್‌ಸೈಟ್ / URL ನಮೂದಿಸಿ",
    ok: "ಸರಿ",
    alert: "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಆಯ್ಕೆಮಾಡಿ.",
  },
};

const SuspectPlatform = ({
  onNext,
  onSuspectContactSelected,
  onSuspectRadio,
  onQuestion,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  answer,
  selectedLang
}) => {
  const [suspectContacts, setSuspectContacts] = useState({
    contactValues: [],
    contactIds: [],
  });
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [platFormOptions, setPlatFormOptions] = useState([]);
  const [rawPlatFormData, setRawPlatFormData] = useState(null);
  const [isYesSelected, setIsYesSelected] = useState(null);
  const [previousSelectedContacts, setPreviousSelectedContacts] = useState(null);
  const [isPlayingPlatform, setIsPlayingPlatform] = useState(false);
  const [isPlayingLinks, setIsPlayingLinks] = useState(false);
  // Separate refs for each audio element
  const audioRefPlatform = useRef(null);
  const audioRefLinks = useRef(null);

  // Mapping language codes to audio source files for links and platform
  const audioMap = {
    en: "audio/English BOT Audios/anylink.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio17.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio17.m4a",
    tcy: "audio/cybervictim_tcy.mp3"
  };

  const audio = {
    en: "audio/English BOT Audios/suspectplatform.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio18.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio18.m4a",
    tcy: "audio/cybervictim_tcy.mp3"
  };


  // Update the platform audio element when language or play state changes
  useEffect(() => {
    if (audioRefPlatform.current) {
      audioRefPlatform.current.src = audio[selectedLang] || audio["en"];
      audioRefPlatform.current.load();
      if (isPlayingPlatform) {
        audioRefPlatform.current.play();
      }
    }
  }, [selectedLang, isPlayingPlatform]);


         useEffect(() => {
             const handler = () => {
              if (audioRefPlatform.current) {
                audioRefPlatform.current.pause();
                audioRefPlatform.current.currentTime = 0;
                setIsPlayingPlatform(false);
                }
              };
              window.addEventListener('pauseAllAudio', handler);
              return () => window.removeEventListener('pauseAllAudio', handler);
            }, []);

  // Update the links audio element when language or play state changes
  useEffect(() => {
    if (audioRefLinks.current) {
      audioRefLinks.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRefLinks.current.load();
      if (isPlayingLinks) {
        audioRefLinks.current.play();
      }
    }
  }, [selectedLang, isPlayingLinks]);


  useEffect(() => {
    const handler = () => {
     if (audioRefLinks.current) {
      audioRefLinks.current.pause();
      audioRefLinks.current.currentTime = 0;
      setIsPlayingLinks(false);
       }
     };
     window.addEventListener('pauseAllAudio', handler);
     return () => window.removeEventListener('pauseAllAudio', handler);
   }, []);

  useEffect(() => {
    const storedSuspectCall = localStorage.getItem("suspectContact");
    if (storedSuspectCall) {
      const parsedCall = JSON.parse(storedSuspectCall);
      setSuspectContacts(parsedCall);
      onSuspectContactSelected(parsedCall);
      setPreviousSelectedContacts(parsedCall);
    }
  }, []);

  useEffect(() => {
    const storedRadio = localStorage.getItem("radio");
    if (storedRadio) {
      const parsedCall = JSON.parse(storedRadio);
      setIsYesSelected(parsedCall);
      onSuspectRadio(parsedCall);
    }
  }, []);


    const getplatFormList = (resp, language) => {
      switch (language) {
        case "en":
          return resp.lang_eng;
        case "Hi":
          return resp.lang_hin;
        case "Kn":
          return resp.lang_kanada;
        default:
          return resp.lang_eng; // fallback
      }
    };
  
  
    useEffect(() => {
      if (rawPlatFormData) {
        const platFormList = getplatFormList(rawPlatFormData, selectedLang) || [];
        const generateId = (index) => {
          if (index < 26) {
            // For index 0-25, use uppercase letters A-Z.
            return String.fromCharCode(65 + index);
          } else if (index < 52) {
            // For index 26-51, use lowercase letters a-z.
            return String.fromCharCode(97 + index - 26);
          } else {
            // Fallback to numeric or combined identifiers if more than 52 items.
            return index.toString();
          }
        };
        setPlatFormOptions(
          platFormList.map((platForm, index) => ({
            // id: String.fromCharCode(65 + index),
            id: generateId(index),
            value: platForm.splat_uniq,
            label: platForm.splat_nm,
          })) || []
        );
      }
    }, [selectedLang, rawPlatFormData]);
  useEffect(() => {
    const fetchPlatFormData = async () => {
      try {
        const platFormResponse = await fetch(
          `${apiUrl}/v1/cy_ma_suspect_platforms_list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f653d914bc5",
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          }
        );
        if (!platFormResponse.ok) {
          throw new Error("Failed to fetch platform options");
        }
        const platFormData = await platFormResponse.json();
        setRawPlatFormData(platFormData.resp);
        // setOptions(
        //   platFormData.resp.suspect_platforms_list.map((bank, index) => ({
        //     id: String.fromCharCode(65 + index),
        //     value: bank.splat_uniq,
        //     label: bank.splat_nm,
        //   }))
        // );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPlatFormData();
  }, [apiKey, botToken, vist_id, app_ver]);

  const handleOptionClick = (option, e) => {
    e.preventDefault();
    setShowOkButton(true);
    setError("");
    setSuspectContacts((prev) => {
      const contactValues = prev.contactValues.includes(option.value)
        ? prev.contactValues.filter((value) => value !== option.value)
        : [...prev.contactValues, option.value];
      const contactIds = prev.contactIds.includes(option.id)
        ? prev.contactIds.filter((id) => id !== option.id)
        : [...prev.contactIds, option.id];
      const updatedContacts = { contactValues, contactIds };
      localStorage.setItem("suspectContact", JSON.stringify(updatedContacts));
      return updatedContacts;
    });
  };

  const saveDataToAPI = async () => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_multichoice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f653d914bc5",
          qtion_num: "15",
          qtion_option: suspectContacts.contactIds,
          option_val: suspectContacts.contactValues,
          lac_token: botToken,
          app_ver: app_ver,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to save data");
      }
      const data = await response.json();
      if (data.resp.error_code === "0") {
        onSuspectContactSelected(suspectContacts);
        onNext(16);
        onQuestion(17);
      } else {
        setError("Failed to push data to API");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save data, please try again.");
    }
  };

  const handleOkClick = async () => {
    if (audioRefPlatform.current && isPlayingPlatform) {
      audioRefPlatform.current.pause();
      setIsPlayingPlatform(false);
    }
    if (audioRefLinks.current && isPlayingLinks) {
      audioRefLinks.current.pause();
      setIsPlayingLinks(false);
    }
    onSuspectContactSelected(suspectContacts);
    if (
      JSON.stringify(suspectContacts) !== JSON.stringify(previousSelectedContacts)
      
    ) {
      if (suspectContacts.contactValues.length > 0) {
        await saveDataToAPI();
        setPreviousSelectedContacts(suspectContacts);
        // onNext(17);
        // onQuestion(18);
      } else {
        setError('errorSelect');
        setShowOkButton(false);
        return;
      }
    } else {
      onNext(17);
      onQuestion(18);
    }
  };

  const handleRadioChange = (selection, e) => {
    e.preventDefault();
    if (audioRefLinks.current && isPlayingLinks) {
      audioRefLinks.current.pause();
      setIsPlayingLinks(false);
    }
    localStorage.setItem("radio", JSON.stringify(selection));
    onSuspectRadio(selection);
    setIsYesSelected(selection);
    if (selection === "no") {
      onNext(17);
      onQuestion(18);
      setSuspectContacts({ contactValues: [], contactIds: [] });
      localStorage.setItem(
        "suspectContact",
        JSON.stringify({ contactValues: [], contactIds: [] })
      );
    }
  };

  // Separate toggle functions for links and platform audio
  const toggleLinksAudio = (e) => {
    e.preventDefault();
    if (audioRefLinks.current) {
      if (isPlayingLinks) {
        audioRefLinks.current.pause();
        setIsPlayingLinks(false);
      } else {
        audioRefLinks.current.play();
        setIsPlayingLinks(true);
      }
    }
  };

  const togglePlatformAudio = (e) => {
    e.preventDefault();
    if (audioRefPlatform.current) {
      if (isPlayingPlatform) {
        audioRefPlatform.current.pause();
        setIsPlayingPlatform(false);
      } else {
        audioRefPlatform.current.play();
        setIsPlayingPlatform(true);
      }
    }
  };

  const handlePlatformAudioEnd = () => {
    setIsPlayingPlatform(false);
  };

  const handleLinksAudioEnd = () => {
    setIsPlayingLinks(false);
  };

  return (
    <div className="question" style={{ position: "relative", zIndex: "9" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 className="link">
          {translations[selectedLang].header}
          <span style={{ color: "red" }}>*</span>
        </h2>
        <div style={{ display: "flex", marginLeft: "30px" }}>
          <button
            onClick={(e) => handleRadioChange("yes", e)}
            style={{
              marginRight: "5px",
              backgroundColor: isYesSelected === "yes" ? "#007bff" : "initial",
              color: isYesSelected === "yes" ? "white" : "initial",
              border: "1px solid #007bff",
              height:'35px',
              width:'40px',
              fontSize: '12px',
              cursor: "pointer",
              fontWeight:'600'
            }}
          >
            {translations[selectedLang].radioYes}
          </button>
          <button
            onClick={(e) => handleRadioChange("no", e)}
            style={{
              backgroundColor: isYesSelected === "no" ? "#007bff" : "initial",
              color: isYesSelected === "no" ? "white" : "initial",
              border: "1px solid #007bff",
              height:'35px',
              width:'40px',
              fontSize: '12px',
              cursor: "pointer",
              fontWeight:'600'
            }}
          >
            {translations[selectedLang].radioNo}
          </button>
          <button onClick={toggleLinksAudio} className="audio-button" style={{marginTop:'2px'}}>
            {isPlayingLinks ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
          </button>
          <audio ref={audioRefLinks} onEnded={handleLinksAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
        </div>
      </div>
      {isYesSelected === "yes" && (
        <div style={{marginTop:'-12px'}}>
          <div style={{ display: "flex" }}>
            <h2>{translations[selectedLang].platformHeader}</h2>
            <button onClick={togglePlatformAudio} className="audio-button" style={{marginTop:'30px'}}>
              {isPlayingPlatform ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }}/> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }} />}
            </button>
          </div>
          <audio ref={audioRefPlatform} onEnded={handlePlatformAudioEnd}>
            <source src={audio[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div className="call-list">
            {platFormOptions.map((option) => (
              <button
                key={option.id}
                className={`option-button ${
                  suspectContacts.contactValues.includes(option.value) ? "selected" : ""
                }`}
                onClick={(e) => handleOptionClick(option, e)}
                style={{ position: "relative", zIndex: "1000" }}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor: suspectContacts.contactValues.includes(option.value)
                        ? "#000"
                        : "#fff",
                      color: suspectContacts.contactValues.includes(option.value)
                        ? "#fff"
                        : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label" style={{ textAlign: "start" }}>
                    {option.label}
                  </div>
                </div>
                {suspectContacts.contactValues.includes(option.value) && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
          </div>
          {showOkButton && (
            <div style={{ position: "relative", zIndex: "1000", marginTop: "-2px" }}>
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            </div>
          )}
          {answer[16] && (
            <p className="alert-box" style={{ zIndex: "1000" }}>
              {translations[selectedLang].alert}
            </p>
          )}
          {error && (
            <div className="error-message" style={{ position: "relative", zIndex: "1000" }}>
              {translations[selectedLang][error]}
            </div>
          )}
        </div>
      )}
            {answer[15] && isYesSelected === null && (
        <p className="alert-box" style={{ zIndex: "1000", width: "300px" }}>
          {translations[selectedLang].alert}
        </p>
      )}
    </div>
  );
};

export default SuspectPlatform;
